var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":"https://www.asca.org/wp-content/uploads/2016/04/Articles-of-Incorporation.pdf","target":"_blank"}},[_vm._v("ASCA Articles of Incorporation")])
}
var staticRenderFns = []

export { render, staticRenderFns }